import { NotificationManager } from 'react-notifications';
import {
  getIssuerReportsAccessKeyRequest,
  getIssuerReportsDateRequest,
  getIssuerReportsRouteCategoryRequest,
  getIssuerReportsRouteRequest,
  getReportsAccessKeyRequest,
  getReportsDateRequest,
  getReportsIssuerRequest,
  getReportsRouteCategoryRequest,
  getReportsRouteRequest
} from 'src/api/ReportsRequest';
import { checkRequestError } from '.';
import {
  GET_SECTION_API_ACCESS,
  GET_SECTION_DATE,
  GET_SECTION_ISSUER,
  GET_SECTION_ROUTE,
  GET_SECTION_ROUTE_CATEGORY,
  LOAD_REQUEST
} from '../types';

export const getReportsIssuerAction = (filterObj) => async (dispatch) => {
  try {
    dispatch({ type: LOAD_REQUEST });
    const { data } = await getReportsIssuerRequest(filterObj);
    checkRequestError(data);

    dispatch({ type: GET_SECTION_ISSUER, payload: data.content.data });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    // NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const getReportsDateAction = (filterObj, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await getReportsDateRequest(filterObj)
        : await getIssuerReportsDateRequest(filterObj);
    checkRequestError(data);

    dispatch({ type: GET_SECTION_DATE, payload: data.content.data });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const getReportsAccessKeyAction = (filterObj, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await getReportsAccessKeyRequest(filterObj)
        : await getIssuerReportsAccessKeyRequest(filterObj);
    checkRequestError(data);

    dispatch({ type: GET_SECTION_API_ACCESS, payload: data.content.data });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const getReportsRouteAction = (filterObj, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await getReportsRouteRequest(filterObj)
        : await getIssuerReportsRouteRequest(filterObj);
    checkRequestError(data);

    dispatch({ type: GET_SECTION_ROUTE, payload: data.content.data });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};

export const getReportsRouteCategoryAction = (filterObj, profile) => async (
  dispatch
) => {
  try {
    const { data } =
      profile?.super == 1
        ? await getReportsRouteCategoryRequest(filterObj)
        : await getIssuerReportsRouteCategoryRequest(filterObj);
    checkRequestError(data);

    dispatch({
      type: GET_SECTION_ROUTE_CATEGORY,
      payload: data.content.data
    });
    return { message: data.success.message, status: 1 };
  } catch (error) {
    NotificationManager.error(error.message, 'Error');
    return { message: error.message, status: 0 };
  }
};
